module.exports = __webpack_public_path__ + "static/box-bg.f9b8bf17.png";